import { render, staticRenderFns } from "./FinancesGroupDrafts.vue?vue&type=template&id=2da84ca0&"
import script from "./FinancesGroupDrafts.vue?vue&type=script&lang=js&"
export * from "./FinancesGroupDrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports